const swiper = new Swiper(".voice-carousel .carousel-container", {
  // スライダー設定
  slidesPerView: 1.1,
  spaceBetween: 12,
  centeredSlides: true,
  loop: true,
  loopedSlides: 5,
  autoHeight: false,
  speed: 800,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  // ナビゲーション
  navigation: {
    nextEl: ".nav-next",
    prevEl: ".nav-prev",
  },
  // ページネーション
  pagination: {
    el: ".carousel-dots",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + ' dot"></span>';
    },
  },
  // レスポンシブ設定
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: false,
      loop: true,
    },
  },
  // イベントリスナー
  on: {
    transitionEnd: function () {
      // トランジション終了時の処理
      this.autoplay.start();
    },
  },
});